import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_INVOICE_PUBLIC_DOWNLOAD_RECEIPT_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetInvoiceReceiptPayload, GetInvoiceReceiptResult } from '../types/getReceipt.types';

export const PUBLIC_INVOICE_RECEIPT = 'PublicInvoiceReceipt';
export const getPublicInvoiceReceipt = (builder: BuilderType) =>
  builder.query<GetInvoiceReceiptResult, GetInvoiceReceiptPayload>({
    providesTags: [PUBLIC_INVOICE_RECEIPT],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_INVOICE_PUBLIC_DOWNLOAD_RECEIPT_URL,
    }),

    transformResponse: (response: GenericApiResponse<GetInvoiceReceiptResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
